module.exports = __webpack_public_path__ + "img/james-nabrit-jr..213a6c72.png";